export default __webpack_public_path__ + "static/media/icon_report.81842ac8.svg";